import { storeGroupService } from "@/services/storeGroupService";
import { CommonParams, STORE_GROUPS_QUERY_KEYS } from "@/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useGetStoreGroupsMyCompany = (
  params?: CommonParams<{}> & {
    enabled?: boolean;
  }
) => {
  const { enabled = true, ...restParams } = params || {};

  const { data, fetchNextPage, hasNextPage, isFetching } = useInfiniteQuery({
    queryKey: [STORE_GROUPS_QUERY_KEYS.GET_STORE_GROUPS_MY_COMPANY, restParams],
    queryFn: async ({ pageParam = 1 }) =>
      storeGroupService.getStoreGroupMyCompany({
        page: pageParam,
        limit: 20,
        ...restParams,
      }),
    getNextPageParam: (lastPage) => {
      return lastPage.pagination?.hasNextPage
        ? lastPage.pagination.page + 1
        : undefined;
    },
    initialPageParam: 1,
    retry: 1,
    enabled,
  });

  const storeGroups = useMemo(() => {
    return (
      data?.pages
        .flatMap((page) => page.data)
        .map((group) => ({ label: group.name, value: group.id })) || []
    );
  }, [data]);

  return {
    storeGroups,
    fetchNextPage,
    hasNextPage,
    isFetching,
  };
};
